const downsizeCurrencySymbols = () => {
    const priceItems = document.querySelectorAll('.grid-product__price, .product__price, .Products__price, .cart__price, .data-subtotal, .visually-hidden, .grid-product__price--original, .shipping-yen');
    
    priceItems.forEach((priceItem) => {
        if (priceItem.classList.contains('downsized')) return;

        // ¥がすでに <span class="mini-symbol"> で囲まれていないかチェック
        if (!priceItem.innerHTML.includes('<span class="mini-symbol">')) {
            priceItem.innerHTML = priceItem.innerHTML.replace(/¥(?!<\/span>)/g, '<span class="mini-symbol">¥</span>');
        }

        priceItem.classList.add('downsized');
    });
};

window.addEventListener('DOMContentLoaded', () => {
    const observer = new MutationObserver((mutationsList, observer) => {
        observer.disconnect();
        downsizeCurrencySymbols(); 
        observer.observe(document.body, config);
    });

    const config = {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true
    };

    downsizeCurrencySymbols();
    observer.observe(document.body, config);
});
